import '../Header/Header.js';
import '../mod_promo/promo.js';
import '../mod_aside/aside.js';
import '../mod_ege/ege.js';
import '../mod_open-days/filter.js'; //перенести
import '../mod_popup/popup.js';
import '../mod_form/form.js';
import {manageCards} from '../mod_block-info/block-info.js';
import './turn.js';
import {applyBanner} from'../mod_banner/banner.js';
import '../mod_calendar/calendar.js';
import { passTest } from '../mod_express-test/expresstest.js';
import '../mod_search/search-result.js';
import '../mod_search/search-form.js';

import { Lead } from "../mod_zayav/mod_zayav.js"
import { makeOneSearch } from '../mod_aside/aside.js';
const lead = new Lead()
window.lead = lead

/* import '../mod_flipbook/flipbook.js'; */

makeOneSearch();
manageCards(); 
//applyBanner();
document.querySelector('.express-test-questions')&& document.querySelector('.express-test-questions').classList.length===1 ? passTest() : false;
document.querySelector('.header') ? showHidden() : false;


//-SLIDERS

//слайдер фото
$("#represent").slick({
	infinite: false,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	variableWidth: true,
	/* centerMode:true, */
	swipeToSlide: true,
	respondTo: 'window',
});

//слайдер семинары
$("#seminars").slick({
	infinite: false,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	variableWidth: true,
	/* centerMode:true, */
	swipeToSlide: true,
	respondTo: 'window',
});

//слайдер дипломы
$("#diplomas").slick({
	infinite: false,
	slidesToShow: 6,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	swipeToSlide: true,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 5,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				arrows: false,
				draggable: true,
			},
		},
	], 
});
//слайдер благодарности
$("#letters").slick({
	infinite: false,
	slidesToShow: 6,
	slidesToScroll: 1,
	arrows: true,
	dots: false,
	swipeToSlide: true,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 5,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				arrows: false,
				draggable: true,
			},
		},
	], 
});

$('form.ajax-filter').submit(function(){
	let form = $(this);

	$.ajax({
		url: "/ajax.php?mid=" + form.attr('data-mid'),
		type: 'GET',
		data: form.serialize() + '&action=filter',
		dataType: "html",
		success: function(html){
			$('main>.container>section').replaceWith(html);
			makeOneSearch();
			showHidden();
			//applyBlockInfo();
			manageCards();
		},
		error: function(err){}
	});

	return false;
});

$('form.ajax-filter input, form.ajax-filter select, form.ajax-filter .search__container li').not('.no-submit').change(function(e){
	$(this.form).trigger('submit');
});

//подписка на новости

$(".form-news").on("submit", function(){	

	$.ajax({
		url: '/ajax.php?mid=1',
		method: 'POST',
		dataType: 'json',
		data: $(this).serialize(),
		success: function(res){
			if (res["success"]) {
				//console.log(res["text"])

				$(".form-news .content-wrapper").children().not('.flexbox').hide();
				$(".form-news .holder").children().hide();
				$(".form-news .holder").append('<p class="success">' + res["text"] + '</p>');

			} else {
				//console.log(res["text"])
				let inpField = $(".form-news input[type='email']")
				$(".form-news input[type='email']").after('<p class="error">' + res["text"] + '</p>');
				removeError($(inpField));
			}
		},
		error: function(e) {
			console.log(e)
		}
	});
	return false;
});

function removeError (elem) {
	if(elem.next('.error')) {//если после инпута есть сообщение с ошибкой
		elem.focus();
		elem.on('input', function() {//когда инпут очистится, удалить сообщение с ошибкой
			if(elem.val() == '') elem.next('.error').remove();
		})
	}
}

//FLIPBOOKS
$('.flipbook__content').each(function() {
    $(this).turn({
        display: "double",
        acceleration: true,
        elevation: 50,
        duration: 1000,
        autoCenter: true,
    });
});

//Hamburgers
function showHidden() {//TODO:refactoring
	const btnCollapse = document.querySelector('.searchbar__btn-filter');
	const btnHamburger = document.querySelector('.header__collapse-showmenu');
	const btnHeader = document.querySelector('.header__collapse-check')
	const sidebar = document.querySelector('.aside__main');
	const close = document.querySelector('.close');
	const overlay = document.getElementById('overlay');

	console.log('showHidden')

	//гамбургер в шапке
	btnHamburger.addEventListener('click', () => {
		//если открыта боковая панель, то закрыть ее
		if(sidebar && sidebar.classList.contains('open')) {
			sidebar.classList.remove('open');
		} else if(sidebar && !sidebar.classList.contains('open')){
			document.body.classList.toggle('no-scroll');
			overlay.classList.toggle('hidden');
		} else if(!sidebar){
			document.body.classList.toggle('no-scroll');
			overlay.classList.toggle('hidden');
		}
	});

	//гамбургер в боковой панели
	if(btnCollapse) {
		btnCollapse.addEventListener('click', (e) => {
		sidebar.classList.add('open');
		document.body.classList.add('no-scroll');
		overlay.classList.toggle('hidden');
		})
	}	
	const closeEl = (el) => {
		el.classList.remove('open');
	}
	// клик по крестику
	if(close) {
		close.addEventListener('click', () => {
			closeEl(sidebar);
			document.body.classList.remove('no-scroll');
			overlay.classList.add('hidden');
		})
	}
	
	//клик по overlay
	if(overlay) {
		overlay.addEventListener ('click', () => {
			sidebar ? closeEl(sidebar): false;
			btnHeader.checked ? btnHeader.checked=false : false;
			document.body.classList.remove('no-scroll');
			overlay.classList.add('hidden');
		})
	}
}

/*$('.quiz-form').on('submit', function() {
	let form = $(this);
	console.log(form.serialize())
	$.ajax({
		url: 'https://profession-online.ru/ajax.php?mid=32&mode=submit_answers',//TODO:
		method: 'POST',
		dataType: 'json',
		data: form.serialize(), //quiz_id=1 user_id=2
		success: function(data){
			if (data) {
				console.log('success')
				console.log(data)
				//showResult();
				//form.replaceWith('<h1>Спасибо за ответы!</h1>')

			} else {
				//
			}
		},
		error: function(e) {
			console.log('ошибка ')
			console.log(e)
			console.log(e.responseText)
		}
	});
	return false;
})*/
//window.addEventListener('click', event => console.log(new Date, event.target));